module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/img-hotelanddinner-course-fc79f2994ba98d1ea80ed6192386061a.png";